import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Typography, Select, Result, Row, Button, Popconfirm } from 'antd';
import { ORDER_SOURCE_ARRAY } from '@/utils/consts';
import '../index.less';

const { Text } = Typography;
const { Search } = Input;

const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 12
  },
};

const UpdateSource = (props) => {

  const { visible, onCancel, loading, dispatch, form, info, onOk } = props;
  const { getFieldDecorator, validateFields, setFieldsValue } = form;

  useEffect(() => {
   
  }, [visible])

  const handleOk = (value) => {
    validateFields((errors, values) => {
      if (errors) {
        return
      }
      onOk&&onOk({id:info.id,...values});
    })
  }

  return (
    <Modal
      title='修改订单来源'
      visible={visible}
      onCancel={() => { onCancel && onCancel() }}
      onOk={handleOk}
      maskClosable={false}
      destroyOnClose
      confirmLoading={loading.effects['orderList/updateOrderSource']}
    >
     
            <Form {...formItemLayout} style={{ marginTop: 24 }}>
              <Form.Item label='订单来源'>
                {getFieldDecorator('source', {
                  initialValue:info&&info.source,
                  rules: [
                    {
                      required: true,
                      message: '订单来源必填',
                    },
                  ]
                })(<Select>
                  {ORDER_SOURCE_ARRAY.map((item)=>{
                    return <Select.Option value={item.value} key={item.value}>{item.label}</Select.Option>
                  })}
                </Select>)}
              </Form.Item>
            </Form>
    </Modal>
  )
}


export default Form.create()(UpdateSource)